<template>
    <div class="row">
        <div class="col-sm-12">
            <!-- <div class="hidden"><label for="">{{computeChart}}</label></div> -->
            <div v-if="chartHasNoData" class="chart-has-no-data">
              <img src="static/img/no_data.svg" style="">
              <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
                <strong>Info! &nbsp;</strong> No data available
              </b-notification> -->
            </div>

            <div v-else class="chart-wrapper">
                <div class="chart-stage">
                    <highcharts :options="options"></highcharts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name:"barChart",
    props:{
        barChartData:{
            type:Array
        }
    },
    data(){
        return{
            chartHasNoData: false,
            options: {
              chart: {
                  type: null,
                  height: 720
                  // zoomType: 'xy'
              },
              title: {
                  text: 'Loading...',
                  style: {
                      fontSize: '16px',
                      fontFamily: '"Open Sans", sans-serif',
                      fontWeight: '600'
                  }
              },

              subtitle: {
                  text: "Loading...",
                  style: {
                      fontSize: '11px',
                      fontFamily: '"Open Sans", sans-serif',
                      fontWeight: 'normal'
                  }
              },
              credits: {
                enabled: false
              },
              xAxis: {
                  type: 'category',
                  categories: null,
                  title: {
                      text: ''
                  },
                  labels: {
                    style: {
                      fontWeight: 'normal',
                      color: '#686464'
                    }
                  }
              },
              yAxis: {
                  gridLineWidth: 0,
                  minorGridLineWidth: 0,
                  title: {
                      text: ''
                  }
              },
              legend: {
                  enabled: true,
                  // backgroundColor: '#FCFFC5',
                  // borderColor: 'black',
                  // borderRadius: 10,
                  // borderWidth: 3,
                  verticalAlign: 'top',
                  x: -20,
                  y: -15,
              },
              plotOptions: {
                series: {
                  pointWidth: 6,
                  borderWidth: 0,
                  dataLabels: {
                      enabled: true,
                      format: '{point.y:.1f}',
                      style: {
                        fontWeight: 'normal'
                      }
                  },
                  cursor: 'pointer',
                  dashStyle: "Solid",
                  point: {
                  },
                  marker: {
                    lineWidth: 1,
                  },
                  zones: []
                }
              },

              tooltip: {
                  // backgroundColor: '#FCFFC5',
                  // borderColor: 'black',
                  // borderRadius: 10,
                  // borderWidth: 3,
                  // crosshairs: [true, true],
                  headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                  pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}%</b> of total<br/>'
              },
              series:[{
                  name: 'Female',
                  data: [
                      2.1, 2.0, 2.1, 2.3, 2.6,
                      2.9, 3.2, 3.1, 2.9, 3.4,
                      4.3, 4.0, 3.5, 2.9, 2.5,
                      2.7, 2.2, 1.1, 0.6, 0.2,
                      0.0
                  ]
              }],
            exporting: {
              buttons: {
                    contextButton: {
                      menuItems: [
                      "printChart",
                      "separator",
                      "downloadPNG",
                      "downloadJPEG",
                      "downloadPDF",
                      "downloadSVG",
                      "separator",
                      "downloadCSV",
                      "downloadXLS",
                      //"viewData",
                      "openInCloud"
                    ],
                    symbol: 'download',
                    // symbolStrokeWidth: 2,
                    // symbolFill: '#330033',
                    // symbolStroke: '#b3d4fc'
                    }
                }
              }
            }
        }
    },
    methods: {
      computeChart() {
         //this.options.exporting.filename = indicator +" ("+ source +' - '+ this.selectedYear +")";
        var plotData = this.barChartData[0];
        var xAxis = [], yAxis = [];
        Object.keys(plotData).map( (elem, index) => {
          xAxis.push(plotData[elem]);
          yAxis.push(elem);
        })
        var cadre = this.computeCadre(xAxis, yAxis);
        var indicatorSignalType = this.$store.state.CAR.indicatorAttributesOtherSources[this.barChartData[1]];
        var colorType = ['#13b433', '#1E70EC', '#e85d58'] // G, B, R

        var color = [];
        if (indicatorSignalType[0][0] === 'G') {
            color = [0, 2];
        }
        else {
            color = [2, 0]
        }
        var selectedIndicatorShortName = this.$store.getters.getShortIndicatorNames(this.barChartData[1]);
        // ivt = indicator value type
        var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.barChartData[1]];
        var vt = ivt[1] === 'P'? '%': '';
        var it = ivt[1] === 'P'? '% of total': '';

        // for highchart...
        this.options.series = [];
        this.options.xAxis.categories = [];
        this.options.title.text = selectedIndicatorShortName + '-' + this.barChartData[2];

        this.options.tooltip.headerFormat = '<span style="font-size:11px; font-weight:bold; text-decoration: underline">' + this.barChartData[2] +
        '-' + this.barChartData[3] + '</span><br>'
        this.options.tooltip.pointFormat =
          '<span style="color:black; font-weight: bold;">{series.name} - <b>{point.y:.2f}'+it+'</b> </span><br/>';
        this.options.plotOptions.series.dataLabels.format ='{point.y:.1f}'+vt


        var statesNameInOrder = (cadre.top5_yAxis.reverse().concat(cadre.others_yAxis.reverse()))
                                .concat(cadre.least5_yAxis.reverse());
        var statesValuesInOrder = (cadre.top5_xAxis.reverse().concat(cadre.others_xAxis.reverse()))
                                  .concat(cadre.least5_xAxis.reverse());

        this.options.xAxis.categories = statesNameInOrder;
        var temp = cadre.top5_xAxis
        var top5 = {
          name: "Top5",
          data: [
            temp[0],temp[1], temp[2], temp[3], temp[4],
            null,null,null,null,null,
            null,null,null,null,null,
            null,null,null,null,null,
            null,null,null,null,null,
            null,null,null,null,null,
            null,null,null,null,null,
            null,null,null
          ],
          // pointWidth: 4,
          color: colorType[color[0]]
        }

        temp = cadre.others_xAxis
        var others = {
          name:"Others",
          data: [
            null,null,null,null,
            null,temp[0],temp[1], temp[2],
            temp[3], temp[4],temp[5], temp[6],
            temp[7],temp[8],temp[9], temp[10],
            temp[11],temp[12],temp[13], temp[14],
            temp[15],temp[16],temp[17], temp[18],
            temp[19],temp[20],temp[21], temp[22],
            temp[23],temp[24],temp[25], temp[26],
            temp[27], null,null,null,null,null
          ],
          // pointWidth: 4,
          color: '#58a5e8'
        }

        temp = cadre.least5_xAxis
        var least5 = {
          name:"Least 5",
          data: [
            null, null, null, null,
            null, null, null, null,
            null, null, null, null,
            null, null, null, null,
            null, null, null, null,
            null, null, null, null,
            null, null, null, null,
            null, null, null, null,
            null, temp[0],temp[1],
            temp[2],temp[3],
            temp[4]
          ],
          // pointWidth: 4,
          color: colorType[color[1]]
        };
        var stateAndTargetValues = [top5, others, least5];
        stateAndTargetValues.map((elem, index) => {
          if( !elem.data.includes(undefined)){
            this.options.series.push(elem)
          }
        })
        //this.options.series.push(top5, others, least5);
        // console.log(this.options.series);
        return;
      },
      // compute the cadre for the different states
      computeCadre(xAxis, yAxis) {
        // console.log(this.lsTargetData.slice[0])

        //compute the cadre for top states
        var top5_xAxis = xAxis.filter( (elem, index, arr) => {
            return index < 5;
        }).reverse();

        var top5_yAxis = yAxis.filter( (elem, index, arr) => {
            return index < 5;
        }).reverse();

        //compute the cadre for least 5 states
        var least5_xAxis = xAxis.filter( (elem, index, arr) => {
            return index > 32;
        }).reverse();

        var least5_yAxis = yAxis.filter( (elem, index, arr) => {
            return index > 32;
        }).reverse();

        //compute the cadre for other 27 states
        var others_xAxis = xAxis.filter( (elem, index, arr) => {
            return index > 4 && index < 33;
        }).reverse();

        var others_yAxis = yAxis.filter( (elem, index, arr) => {
            return index > 4 && index < 33;
        }).reverse();

        return {top5_xAxis, top5_yAxis, least5_xAxis, least5_yAxis, others_xAxis, others_yAxis};
      },
    },
    computed: {

    },
    mounted () {
    },
    created(){
        this.options.chart.type = 'bar';
        this.options.plotOptions = {
          bar: {
            dataLabels: {
                enabled: true
            }
          }
        }
        this.options.yAxis.gridLineWidth = 1;
        this.options.yAxis.title.text = '';
        this.options.plotOptions.colorByPoint = true;
        this.options.chart.height = 680;

    },
    // },
    // computed: {
    //     sourceClicked() {

    //         this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
    //         var sources = this.tableColumnHeaderAttr[0];
    //         var val = this.tableColumnHeaderAttr[1];
    //         // check for availability of data in the source here

    //         // var defaultSource = this.$store.getters.getDefaultSource;
    //         var selectedSource = sources;//? sources: defaultSource;
    //         this.selectedSource = selectedSource;

    //         // get the the state indicator source object from store
    //         var stateSelectedIndicatorSource = this.$store.getters.getSelectedIndicatorSource;
    //         var selectedIndicatorSource = stateSelectedIndicatorSource[selectedSource];

    //         // console.log(stateSelectedIndicatorSource);
    //         if (selectedIndicatorSource) {
    //             // compute the years custom to the data
    //             var optionYear = [];
    //             Object.keys(stateSelectedIndicatorSource).map( (elem, index) => {
    //                 if (stateSelectedIndicatorSource[elem].length > 0) {
    //                     optionYear.push(stateSelectedIndicatorSource[elem][0])
    //                 }
    //             })
    //             this.optionYear = optionYear; // assign to select year field

    //             // get the indicator selected, and watch the year of its current value.
    //             if (selectedIndicatorSource.length > 0) {
    //                 this.selectedYear = selectedIndicatorSource[0];
    //             }
    //         }
    //         return selectedSource;
    //     },
    //     indicatorSelected() {

    //         this.selectedIndicator = this.$store.getters.getSelectedIndicator;
    //         var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
    //         return 'Some values';
    //     },
    //     selectedIndicatorShortName () {

    //         // send message to reset list of sources...
    //         return this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
    //     },
    // },
    updated() {
      this.computeChart();
    },
    watch: {
      barChartData: {

        handler(val) {
          // this.computeChart;
          var anyValueInMapData = Object.keys(val[0]).filter((e, i, arr) => {
            return val[0][e] !== undefined;
          });
          if (anyValueInMapData.length === 0) {
            this.chartHasNoData = true;
          }else{
            this.chartHasNoData = false;
          }
          this.computeChart();
        },
        immediate: true,
        deep: true
      }
    }
}
</script>



// WEBPACK FOOTER //
// barChart.vue?8c098e24